import { FetchStatus } from '@flatsy/types/FetchStatus'
import { createAsyncThunk } from '@reduxjs/toolkit'
import * as URLS from 'src/constants/Api'
import client from 'src/utils/client'
import { RootState } from '../..'
import { Asset } from './Type'

export const fetchAsset = createAsyncThunk<
  Asset,
  {
    id: string
  },
  { rejectValue: { code: number } }
>(
  'assets/fetchAsset',
  async ({ id }, { rejectWithValue }) => {
    return client<Asset>(URLS.PUBLICASSETS_BY_URL_ID(id, 'url_id')).catch((err) => {
      return rejectWithValue(err)
    })
  },
  {
    condition: (_, { getState }) => {
      const r = (getState as () => RootState)().assets.status
      if (r === FetchStatus.LOADING) {
        return false
      }
    },
  }
)
